/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
import { useState } from "react";
import styled, { css } from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQuery";
import Mixpanel from "../../utils/Mixpanel";
import { getUrlPath } from "../../utils/helpers";

const EMPLOYER_FAQS = [
	{
		question: "How can I hire the best people for my job?",
		answer: "On apna app, thousands of profiles are shown your job and our algorithm ensures only the best fit is able to reach out to you.",
	},
	{
		question: "Bulk hiring costs a lot of money, how do I save my business expense?",
		answer: "Most hiring portals have a database and reaching out to candidates costs a lot of money. On apna app, we take a social approach - so hiring costs are the lowest in the industry.",
	},
	{
		question: "I am not able to hire people on LinkedIn. How can I improve?",
		answer: "LinkedIn was a platform built for white-collar professionals who are great at networking. For entry-level jobs, try a simple platform like apna that people love and spend enough time on.",
	},
	{
		question: "How important is a CV for my hiring?",
		answer: "Ask yourself - does your job demand a specific skill? Like delivery or retail or calling? Then you don't necessary even need a CV if you can get job-ready candidates.",
	},
	{
		question: "Candidates don't stay in my job and leave. What do I do?",
		answer: "Fighting natural behaviour is not the right thing to do. Always ensure you have a backup of at least 1 candidate ready for every position in your organisation. A low-cost platform like apna hire can help ensure flow of the right candidates.",
	},
];

const FAQAccordion = ({ question, answer, source }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleFaqAccordion = () => {
		if (!isExpanded) {
			Mixpanel.track(`${source} FAQ Question Expanded`, {
				"Page URL": typeof window !== "undefined" && window.location.href,
				Question: `${question}`,
				page: getUrlPath(),
			});
		}
		setIsExpanded(!isExpanded);
	};

	return (
		<FaqContainer>
			<FaqWrapper>
				<FaqHeadingContainer onClick={toggleFaqAccordion}>
					<FaqHeadingWrapper>
						<FaqHeading>{question}</FaqHeading>
						<FaqIconContainer>
							<FaqIcon>{isExpanded ? "-" : "+"}</FaqIcon>
						</FaqIconContainer>
					</FaqHeadingWrapper>
				</FaqHeadingContainer>
				<FaqAnswerContainer showAnswer={isExpanded}>
					<FaqAnswer>{answer}</FaqAnswer>
				</FaqAnswerContainer>
			</FaqWrapper>
		</FaqContainer>
	);
};

const FAQsSection = ({ faqData, source }) => {
	const FAQS = faqData || EMPLOYER_FAQS;

	return (
		<Container>
			<Wrapper>
				<HeadingContainer>
					<Heading>Frequently asked questions</Heading>
					{FAQS &&
						FAQS.map((data, index) => (
							<FAQAccordion
								key={index}
								question={data.question}
								answer={data.answer}
								source={source}
							/>
						))}
				</HeadingContainer>
			</Wrapper>
		</Container>
	);
};

// Styles
const HeadingContainer = styled.div``;
const Heading = styled.h2`
	font-size: 32px;
	font-weight: 900;
	line-height: 1.38;
	color: #373737;

	${mediaMaxWidth.medium`
        font-size: 19px;
        line-height: normal;
    `}
`;
const FaqContainer = styled.div`
	width: 100%;
	padding: 20px 0;
`;
const FaqWrapper = styled.div``;
const FaqHeadingContainer = styled.div`
	cursor: pointer;
`;
const FaqHeadingWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
const FaqHeading = styled.div`
	font-size: 20px;
	font-weight: 500;
	color: #373737;
	margin-right: 33px;

	${mediaMaxWidth.medium`
        font-size: 15px;
    `}
`;
const FaqIconContainer = styled.div``;
const FaqIcon = styled.div`
	width: 32px;
	height: 32px;
	border-radius: 4px;
	background-color: rgba(43, 183, 147, 0.2);
	color: #2bb793;
	text-align: center;
	font-size: 30px;
	line-height: 32px;
`;
const FaqAnswerContainer = styled.div`
	overflow: hidden;
	max-height: ${(props) => (props.showAnswer ? "1200px" : 0)};
`;
const FaqAnswer = styled.p`
	font-size: 16px;
	color: #6a6a6a;
	margin: 8px 0 0;
	${mediaMaxWidth.medium`
        font-size: 13px;
    `}
`;

const Container = styled.div`
	& ${FaqContainer}:not(:last-child) {
		border-bottom: 1px solid rgba(216, 216, 216, 0.5);
	}
`;

const Wrapper = styled.div`
	${({ showFaqOnly }) =>
		showFaqOnly &&
		css`
			& ${Heading} {
				text-align: center;
			}
			& ${FaqContainer} {
				margin: 0 auto;
				max-width: 100%;
			}
		`}
`;

export default FAQsSection;
